// eslint-disable-next-line import/no-unresolved
import alt from 'alt.js';
import Model from '../utils/model';
import { generateRandomString } from '../utils/core';

class EditorActions {

    openFlow(id, name) {
        return {
            id,
            name,
        };
    }

    openPageLayout(id, name) {
        return {
            id,
            name,
            command: 'edit',
        };
    }

    openEditor(editorDetails) {
        return editorDetails;
    }

    newPageLayout(key, pageName, pageId = null) {
        return {
            id: pageId || Model.guid(),
            name: pageName || 'New Page',
            command: 'new',
            key: key || generateRandomString(16),
        };
    }

    setEditorPageId(newId, oldId) {
        return {
            newId,
            oldId,
        };
    }

    setEditorNameAndType(id, name, type = null) {
        return {
            id,
            name,
            type,
        };
    }

    close(id, flowId) {
        return { id, flowId };
    }
    
    closeAll() {
        return true;
    }

    closePage(id) {
        return id;
    }

    openTenantSelector() {
        return true;
    }

    closeTenantSelector() {
        return true;
    }

}

export default alt.createActions(EditorActions);
